import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PriceRevealComponent from '@nykaa/sitewide-prices-revealed';
import { deviceTypes } from '@nykaa/prices-revealed-shared/constants';
import { AddToDynamicWishlist, HandleAddToDynamicWishlistParams, ParamsForSnackBarCallback } from '@nykaa/prices-revealed-shared/types';
import { State } from 'store/types';
import Snackbar from 'components/Snackbar';
import { redirectAuthPage } from 'shared/helpers/auth';
import { useIsLoggedIn } from 'hooks/auth';


interface Props {
  currentSkuId: string;
  childSku: string;
  itemsInDynamicWishlist: string[];
  fetchDynamicWishlist: ({ bucket }: { bucket: string }) => Promise<void>;
  addToDynamicWishlist: AddToDynamicWishlist;
  type: string;
}

const deviceType = deviceTypes.D_SITE;

function View({
  itemsInDynamicWishlist,
  currentSkuId,
  childSku,
  type,
  fetchDynamicWishlist,
  addToDynamicWishlist,
}: Props) {
  const config = useSelector((state: State) => state.remoteConfig.configs.priceReveal);
  const user = useSelector((state: State) => state.auth.user);
  const [snackbarData, setSnackbarData] = useState<ParamsForSnackBarCallback>({
    show: false,
    isError: false,
    message: '',
  });
  const isLoggedIn = useIsLoggedIn();
  const { isError, message, show } = snackbarData;

  const handleAddToDynamicWishlist = (data: HandleAddToDynamicWishlistParams) => {
    const {
      bucket,
      productId,
      onSuccess,
      onError,
    } = data;
    addToDynamicWishlist({
      bucket,
      productId,
      deviceType,
    })
    .then(() => onSuccess())
    .catch(() => onError());
  };

  const handleSnackbarClose = () => {
    setSnackbarData({
      isError: false,
      message: '',
      show: false,
    });
  };

  if (!config?.active) return null;

  return (
    <>
      <PriceRevealComponent
        itemsInDynamicWishlist={itemsInDynamicWishlist}
        currentSkuId={currentSkuId}
        childSku={childSku}
        type={type}
        config={config}
        userData={user}
        fetchDynamicWishlist={fetchDynamicWishlist}
        onAddToDynamicWishlistClick={handleAddToDynamicWishlist}
        redirectAuthPage={redirectAuthPage}
        setSnackbar={setSnackbarData}
        deviceType={deviceType}
        isLoggedIn={isLoggedIn}
      />
      {
        (show) && (
          <Snackbar
            autoClose
            closeCallback={handleSnackbarClose}
            content={message}
            snackBarId="prices-revealed"
            errorType={isError}
          />
        )
      }
    </>
  );
}

export default View;
